import { createContext } from "react";
import { GraphEntryStore } from "../../store";

export const GraphEntryContext = createContext<GraphEntryStore | null>(null);
